import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, IconButton, Skeleton, Box } from "@mui/material";
import { ExpandMore } from "@mui/icons-material"; // Import the icon
import { StringsService } from "../services/strings/strings";

interface AsyncStringProps {
  stringId: string;
  onLoad?: () => void;
  style?: React.CSSProperties;
  maxLength?: number; // Option to specify max length for truncation
}

const AsyncString: React.FC<AsyncStringProps> = ({ stringId, style, onLoad, maxLength = 100 }) => {
  const [text, setText] = useState<string>("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const fetchString = async () => {
      const result = await StringsService.getStringById(stringId);
      setText(result || ""); // Default to an empty string if not found
      setIsLoaded(true);
      onLoad?.();
    };

    fetchString();
  }, [stringId]);

  const isTruncated = text.length > maxLength;
  const truncatedText = isTruncated ? text.slice(0, maxLength) + "..." : text;

  const handleOpenDialog = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (isTruncated) {
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = (event: React.MouseEvent) => {
    event.stopPropagation();
    setOpenDialog(false);
  };

  return (
    <Box>
      {isLoaded ? (
        <>
          <span style={style}>{isTruncated ? truncatedText : text}</span>
          {isTruncated && (
            <IconButton
              onClick={handleOpenDialog}
              sx={{
                padding: 0,
                marginLeft: 1,
                fontSize: '1.5rem',
                alignSelf: "center",
              }}
            >
              <ExpandMore fontSize="medium" />
            </IconButton>
          )}
        </>
      ) : (
        <Skeleton style={style} variant="text" width={300} height={20} />
      )}

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Read More</DialogTitle>
        <DialogContent>
          <Typography>{text}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleCloseDialog(e)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AsyncString;
